import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-679b5e95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "client-table-container" }
const _hoisted_2 = { class: "terminal-list-stack" }
const _hoisted_3 = { class: "btn-group cm-ui-mb16" }
const _hoisted_4 = { class: "right-bar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-search",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_6 = { class: "left-bar" }
const _hoisted_7 = { class: "cm-align-center" }
const _hoisted_8 = { class: "cm-align-center" }
const _hoisted_9 = { class: "text-button-group cm-ui-mb16" }
const _hoisted_10 = {
  t: "1774858782869",
  class: "icon",
  style: {"margin-right":"3px"},
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "7027",
  width: "17",
  height: "17"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512 910.222336c219.931648 0 398.222336-178.290688 398.222336-398.222336 0-219.931648-178.290688-398.222336-398.222336-398.222336-219.931648 0-398.222336 178.290688-398.222336 398.222336 0 219.931648 178.290688 398.222336 398.222336 398.222336z m0 56.88832C260.64896 967.110656 56.889344 763.35104 56.889344 512S260.64896 56.889344 512 56.889344 967.110656 260.64896 967.110656 512 763.35104 967.110656 512 967.110656z",
  fill: "var(--el-color-primary)",
  "p-id": "7028"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M483.150848 394.958848l-110.32576 110.326784c-11.109376 11.108352-29.119488 11.108352-40.226816 0-11.108352-11.108352-11.108352-29.11744 0-40.225792l181.018624-181.019648 40.226816 40.226816L694.636544 465.05984c11.108352 11.108352 11.108352 29.11744 0 40.225792-11.108352 11.108352-29.118464 11.108352-40.226816 0l-114.37056-114.369536V710.7072c0 15.70816-12.734464 28.443648-28.443648 28.443648-15.709184 0-28.444672-12.734464-28.444672-28.443648V394.958848z",
  fill: "var(--el-color-primary)",
  "p-id": "7029"
}, null, -1))
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8.36621 1C8.63463 1.00009 8.8921 1.10819 9.08008 1.2998L12.7139 5.00391C12.8972 5.19081 12.9999 5.44227 13 5.7041V8H12V6.0127H8V2H3V14H7V15H2.99512C2.5199 14.9999 2.00002 14.6627 2 14.0781V1.92188C2.00002 1.33735 2.5199 1.00011 2.99512 1H8.36621ZM9 5.0127H11.3213L9 2.64648V5.0127Z",
    fill: "var(--el-color-primary)"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M13.0977 10.7881V13.2109L11 14.4229L8.90234 13.2109V10.7881L11 9.57617L13.0977 10.7881Z",
    stroke: "var(--el-color-primary)"
  })
], -1))
const _hoisted_15 = { class: "selection-bar cm-ui-mb16" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "cm-align-center gap-x-10 cm-a-link",
  style: {"justify-content":"center"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-right" }, null, -1))
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "remark-cell" }
const _hoisted_22 = { style: {"display":"inline-block"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_GroupTreeSelector = _resolveComponent("GroupTreeSelector")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BlueTipsIcon = _resolveComponent("BlueTipsIcon")!
  const _component_UnauthorizedTooltip = _resolveComponent("UnauthorizedTooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_TerminalIconName = _resolveComponent("TerminalIconName")!
  const _component_EditableField = _resolveComponent("EditableField")!
  const _component_IPColumn = _resolveComponent("IPColumn")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_LoadMoreButton = _resolveComponent("LoadMoreButton")!
  const _directive_disabled = _resolveDirective("disabled")!
  const _directive_date_format = _resolveDirective("date-format")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_load_more = _resolveDirective("load-more")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_input, {
            size: "small",
            class: "search-input",
            modelValue: _ctx.page.searchKeyword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page.searchKeyword) = $event)),
            onChange: _ctx.handleSearch,
            placeholder: _ctx.$t('groupClient.searchPlaceholder')
          }, {
            suffix: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["modelValue", "onChange", "placeholder"]),
          _createVNode(_component_el_select, {
            class: "cm-ui-mr10 cm-ui-ml10",
            size: "small",
            modelValue: _ctx.page.options.system_type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.page.options.system_type) = $event)),
            onChange: _ctx.handleSearch,
            placeholder: _ctx.$t('groupClient.osPlaceholder'),
            clearable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.terminalTypeOptions, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: +item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange", "placeholder"]),
          _createVNode(_component_el_select, {
            size: "small",
            modelValue: _ctx.page.options.login_status,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page.options.login_status) = $event)),
            placeholder: _ctx.$t('groupClient.terminalStatusPlaceholder'),
            onChange: _ctx.handleSearch,
            class: "cm-ui-mr10",
            clearable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus.options, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder", "onChange"]),
          _createVNode(_component_GroupTreeSelector, {
            class: "group-tree-in-toolbar",
            "default-group-id": _ctx.page.options.group_id,
            onSelected: _ctx.terminalGroupIdSelected
          }, null, 8, ["default-group-id", "onSelected"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            disabled: !_ctx.page.state.selectCount,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal('MODAL_CLIENT_MOVE_TERMINAL')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('groupClient.moveTo')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            disabled: !_ctx.total,
            plain: "",
            size: "small",
            onClick: _ctx.downloadCSV
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_CmSvgIcon, {
                  name: "assets/icons/export",
                  class: "cm-ui-mr5",
                  monochrome: "",
                  size: 16,
                  color: "var(--el-color-primary)"
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('groupClient.exportInfo')), 1)
              ])
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_popover, {
            placement: "bottom",
            trigger: "click",
            width: "auto"
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_CmSvgIcon, {
                      name: "assets/icons/custom-col",
                      class: "cm-ui-mr5",
                      monochrome: "",
                      size: 16,
                      color: "var(--el-color-primary)"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('groupClient.customColumns')), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox_group, {
                "model-value": _ctx.page.checkedColumns,
                onChange: _ctx.handleCheckedColumnChange,
                style: {"min-width":"150px","max-width":"180px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTableColumns, (column) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      style: {"padding":"5px"},
                      label: column.c_key,
                      key: column.c_key
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(column.c_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["model-value", "onChange"])
            ]),
            _: 1
          }),
          (!_ctx.HIDE_FUNC.locationInfo)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                icon: "el-icon-location-outline",
                size: "small",
                onClick: _ctx.openFleetMap
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('groupClient.terminalLocation')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.TableViewMode.preview === _ctx.viewMode)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "",
                size: "small",
                plain: "",
                onClick: _ctx.openTerminalListDrawer
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('groupClient.viewAllTerminals')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "text-button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal('MODAL_CLIENT_REGISTE_INFO')))
        }, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/group/client/_images/register",
            monochrome: ""
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.completeRegisterInfo')), 1)
        ])), [
          [_directive_disabled, !_ctx.page.state.selectCount]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "text-button",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal('MODAL_PUSH_MODAL')))
        }, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/group/client/_images/push",
            monochrome: ""
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.pushMessage')), 1)
        ])), [
          [_directive_disabled, !_ctx.page.state.selectCount]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "text-button",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.upgradeClient && _ctx.upgradeClient(...args)))
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_10, _hoisted_13)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.upgradeClient')), 1)
        ])), [
          [_directive_disabled, !_ctx.page.state.selectCount]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "text-button",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openModal('MODAL_CLIENT_SHUTDOWN')))
        }, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/group/client/_images/shutdown",
            monochrome: ""
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.shutdown')), 1)
        ])), [
          [_directive_disabled, _ctx.calcDisabledStatus()]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "text-button",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openModal('MODAL_CLIENT_REBOOT')))
        }, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/group/client/_images/restart",
            monochrome: ""
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.reboot')), 1)
        ])), [
          [_directive_disabled, _ctx.calcDisabledStatus()]
        ]),
        _createElementVNode("div", {
          class: "text-button",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openModal('MODAL_CLIENT_BLACKLIST')))
        }, [
          _createVNode(_component_CmSvgIcon, {
            name: "views/dashboard/group/client/_images/blacklist",
            monochrome: ""
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.terminalBlacklist')), 1)
        ]),
        _createVNode(_component_router_link, {
          class: "text-button",
          to: "/dashboard/asset-registration",
          style: {"text-decoration":"none"}
        }, {
          default: _withCtx(() => [
            _hoisted_14,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.assetRegistrationSetting')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_BlueTipsIcon, { class: "cm-ui-ml15 cm-ui-mr10" }),
        _createElementVNode("p", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('groupClient.selectedCountTerminals')) + " ", 1),
          _createElementVNode("a", {
            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.getListByMemory && _ctx.getListByMemory(...args))),
            disabled: !_ctx.page.state.selectCount,
            class: _normalizeClass(!_ctx.page.options.useMemory ? 'req-primary' : 'req-default')
          }, _toDisplayString(_ctx.page.state.selectCount), 11, _hoisted_16),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('groupClient.terminalsUnit')), 1)
        ]),
        (_ctx.page.state.pageSelectCount < _ctx.pageRowCount)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              disabled: _ctx.calcActionBtnDisableStatus(),
              class: "btn cm-ui-ml10",
              type: "text",
              onClick: _ctx.togglePageSelect
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('groupClient.selectPage')), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          class: "btn",
          type: "text",
          disabled: _ctx.calcActionBtnDisableStatus(),
          onClick: _ctx.selectAll
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('groupClient.selectAllGroup')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"]),
        _createVNode(_component_el_button, {
          class: "btn",
          type: "text",
          disabled: !_ctx.page.state.selectCount,
          onClick: _ctx.selectCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('groupClient.cancelSelect')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "innerTable",
        class: "table-content",
        data: _ctx.rows,
        width: "100%",
        height: _ctx.tableHeight,
        "tooltip-effect": "light",
        "row-key": "device_id",
        onSortChange: _ctx.handlerSort,
        onSelectionChange: _ctx.handleSelectionChange,
        onSelect: _ctx.handleSelectionChange
      }, {
        empty: _withCtx(() => [
          (!_ctx.loading && !_ctx.page.options.login_status && !_ctx.page.options.system_type && !_ctx.page.options.key_word && _ctx.page.options.group_id === -1 && !_ctx.page.options.useMemory)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('groupClient.noDeployTip')), 1),
                _createTextVNode(),
                _hoisted_18,
                _createVNode(_component_router_link, { to: "/dashboard/client-alive" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('groupClient.deployNow')), 1)
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.$t('common.noData')), 1))
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            selectable: (row) => !(_ctx.page.state.selectAll || _ctx.isDisabled(row))
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_UnauthorizedTooltip, {
                "permission-key": _ctx.modulePermissionKey[scope.row.area_type],
                "device-id": scope.row.device_id,
                "auth-status": _ctx.getAuthByList(scope.row.auth_status, _ctx.modulePermissionKey[scope.row.area_type]),
                "area-type": scope.row.area_type,
                onAuthSuccess: _ctx.reloadData
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    "model-value": scope.row.$selected,
                    disabled: _ctx.page.state.selectAll || _ctx.isDisabled(scope.row),
                    onChange: ($event: any) => (_ctx.handleCheckbox(scope.row))
                  }, null, 8, ["model-value", "disabled", "onChange"])
                ]),
                _: 2
              }, 1032, ["permission-key", "device-id", "auth-status", "area-type", "onAuthSuccess"])
            ]),
            _: 1
          }, 8, ["selectable"]),
          (_ctx.page.checkedColumns.includes('computer_name'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                prop: "computer_name",
                "min-width": 200,
                label: _ctx.$t('groupClient.computerName'),
                fixed: "",
                sortable: "custom",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_TerminalIconName, {
                    class: "cm-link",
                    onClick: ($event: any) => (_ctx.handleClickName(scope.row)),
                    computer_name: scope.row.computer_name,
                    system_type: scope.row.system_type,
                    login_status: scope.row.login_status
                  }, null, 8, ["onClick", "computer_name", "system_type", "login_status"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.page.checkedColumns.includes('user_mark'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 1,
                "min-width": 150,
                label: _ctx.$t('groupClient.registerUserName'),
                sortable: "custom",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_EditableField, {
                    value: scope.row.user_mark,
                    onBlur: ($event: any) => (_ctx.editUserMark($event, scope.row))
                  }, null, 8, ["value", "onBlur"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            prop: "group_name",
            label: _ctx.$t('groupClient.groupName'),
            "min-width": 100
          }, null, 8, ["label"]),
          (_ctx.page.checkedColumns.includes('ip'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 2,
                label: _ctx.$t('groupClient.ipAddress'),
                "min-width": 180
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_IPColumn, {
                    cip: scope.row.client_ip,
                    sip: scope.row.system_ip
                  }, null, 8, ["cip", "sip"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.page.checkedColumns.includes('system_name'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 3,
                "min-width": 150,
                prop: "system_name",
                label: _ctx.$t('groupClient.os'),
                sortable: "custom"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.page.checkedColumns.includes('version'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 4,
                prop: "version",
                "min-width": 120,
                label: _ctx.$t('groupClient.terminalVersion'),
                sortable: "custom"
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.page.checkedColumns.includes('login_status'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 5,
                prop: "login_status",
                "min-width": 120,
                label: _ctx.$t('groupClient.terminalStatus'),
                sortable: "custom"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.login_status == 1 ? _ctx.$t('groupClient.online') : _ctx.$t('groupClient.offline')), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.page.checkedColumns.includes('mac'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 6,
                prop: "mac",
                "min-width": 150,
                label: _ctx.$t('groupClient.macAddress'),
                "show-overflow-tooltip": ""
              }, null, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.page.checkedColumns.includes('current_startup_time'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 7,
                "min-width": 160,
                label: _ctx.$t('groupClient.currentBootTime'),
                prop: "current_startup_time",
                sortable: "custom"
              }, {
                default: _withCtx((scope) => [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_date_format, { value: scope.row.current_startup_time * 1000, format: 'YYYY-MM-DD HH:mm' }]
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.page.checkedColumns.includes('today_online_time'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 8,
                "min-width": 160,
                label: _ctx.$t('groupClient.todayOnlineDuration'),
                prop: "today_online_time",
                sortable: "custom",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_ctx.calcOnlineTime(scope.row.today_online_time)), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.page.checkedColumns.includes('last_startup_time'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 9,
                "min-width": 150,
                label: _ctx.$t('groupClient.lastBootTime'),
                prop: "last_startup_time",
                sortable: "custom",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_date_format, { value: scope.row.last_startup_time * 1000, format: 'YYYY-MM-DD HH:mm' }]
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.page.checkedColumns.includes('last_offline_time'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 10,
                "min-width": 150,
                label: _ctx.$t('groupClient.lastOfflineTime'),
                prop: "last_offline_time",
                sortable: "custom",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx((scope) => [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_date_format, { value: scope.row.last_offline_time * 1000, format: 'YYYY-MM-DD HH:mm' }]
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (!_ctx.HIDE_FUNC.service__auth && !_ctx.IS_JP_ONLY_BUILD)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 11,
                "min-width": 150,
                label: _ctx.$t('groupClient.configuredService'),
                prop: "service_count",
                sortable: ""
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", {
                    class: "cm-link-light",
                    onClick: ($event: any) => (_ctx.handleClickServiceCount(scope.row))
                  }, _toDisplayString(scope.row.service_count || 0), 9, _hoisted_20)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('discoveredList.vendorInfo'),
            minWidth: 250
          }, {
            default: _withCtx(({row}) => [
              _createElementVNode("span", null, _toDisplayString(!row.hardware_info ? '--' : row.hardware_info), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.page.checkedColumns.includes('remark'))
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 12,
                "min-width": 180,
                "show-overflow-tooltip": ""
              }, {
                header: _withCtx(() => [
                  _createVNode(_component_el_tooltip, {
                    placement: "top",
                    effect: "light"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('groupClient.teamManagerRemarkTooltip')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remark')), 1),
                        _createVNode(_component_CmSvgIcon, {
                          name: "assets/icons/warn-border-gray",
                          class: "cm-ui-ml5",
                          size: 16,
                          monochrome: ""
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx((scope) => [
                  _createVNode(_component_el_tooltip, {
                    placement: "top",
                    effect: "light",
                    disabled: !_ctx.getRemarkOperatorName(scope.row)
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getRemarkOperatorName(scope.row)), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_EditableField, {
                          value: scope.row.remark,
                          onBlur: ($event: any) => (_ctx.editUserMark($event, scope.row, true))
                        }, null, 8, ["value", "onBlur"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["disabled"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: _ctx.$t('groupClient.operation'),
            "min-width": 180
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.viewDefencePolicy(scope.row)),
                type: "text",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('groupClient.defencePolicy')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                onClick: ($event: any) => (_ctx.deleteClientRow(scope.row)),
                type: "text",
                class: "cm-link-danger",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remove')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              (!_ctx.HIDE_FUNC.remoteAssist)
                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                    key: 0,
                    "append-to-body": "",
                    disabled: !_ctx.getRemoteDisableTip(scope.row),
                    effect: "light",
                    content: _ctx.getRemoteDisableTip(scope.row),
                    placement: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_el_button, {
                          onClick: ($event: any) => (_ctx.openRemoteAssist(scope.row)),
                          disabled: !!_ctx.getRemoteDisableTip(scope.row),
                          type: "text",
                          size: "small"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('groupClient.remoteOp')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["disabled", "content"]))
                : _createCommentVNode("", true),
              (!_ctx.HIDE_FUNC.locationInfo)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    onClick: ($event: any) => (_ctx.handleClickLocation(scope.row)),
                    type: "text",
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('groupClient.locationInfo')), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "height", "onSortChange", "onSelectionChange", "onSelect"])), [
        [_directive_loading, _ctx.loading],
        [_directive_load_more, _ctx.loadMoreDirectiveMerged]
      ]),
      (_ctx.viewMode === _ctx.TableViewMode.full)
        ? (_openBlock(), _createBlock(_component_LoadMoreButton, {
            key: 0,
            "has-more": _ctx.loadMoreHasMore,
            loading: _ctx.loadMoreLoading,
            current: _ctx.loadMoreCurrent,
            total: _ctx.loadMoreTotal,
            onLoadMore: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('load-more')))
          }, null, 8, ["has-more", "loading", "current", "total"]))
        : _createCommentVNode("", true)
    ])
  ]))
}